export const sociology = [
    {
      q: "Термин „социологија“ први је употребио:",
      a: ["Огист Конт", "Рајт Милс", "Роберт Мертон", "Михаило Поповић"],
    },    
    {
      q: "Генеричко објашњење одговара на питање о:",
      a: ["пореклу појаве", "узроку појаве", "потребама које појаве задовољавају", "структури појаве"],
    },    
    {
      q: "Узрочно објашњење одговара на питање о:",
      a: ["узроку појаве", "пореклу појаве", "потребама које нека појава задовољава", "структури појаве"],
    },    
    {
      q: "Функционално објашњење одговара на питање о:",
      a: ["потребама које нека појава задовољава", "узроку појаве", "генези појаве", "структури појаве"],
    },    
    {
      q: "Структурално објашњење одговара на питање:",
      a: ["који елементи чине неку појаву", "о генези појаве", "о потребама које нека појава задовољава", "о структури појаве"],
    },    
    {
      q: "Разумевање је научни поступак којим се открива:",
      a: ["значење које актери придају својим поступцима", "функција појаве", "структура појаве", "генеза појаве"],
    },    
    {
      q: "Теорија је:",
      a: ["скуп повезаних исказа којима се објашњава нека појава", "научни закон", "научна хипотеза", "врста експеримента"],
    },    
    {
      q: "Скуп исказа којима се објашњава нека појава назива се:",
      a: ["теорија", "друштвена норма", "друштвени положај", "друштвена улога"],
    },    
    {
      q: "Метод је:",
      a: ["начин проучавања", "теорија једне науке", "верска секта", "друштвена група"],
    },    
    {
      q: "Квалитативна метода предност даје:",
      a: ["исказима испитаника", "статистичким подацима", "документима", "звучним изворима"],
    },
    {
      q: "Група људи од којих се тражи обавештење назива се:",
      a: ["узорак", "контролна група", "експериментална група", "радна група"],
    },
    {
      q: "Логичка радња којом се једна група појава дели на врсте међусобно сродних појава зове се:",
      a: ["класификација", "мерење", "социометрија", "анализа садржаја"],
    },
    {
      q: "На значај разумевања друштвеног делања указује:",
      a: ["Макс Вебер", "Роберт Мертон", "Огист Конт", "Карл Маркс"],
    },
    {
      q: "Homo faber значи:",
      a: ["производно биће", "свесно биће", "породично биће", "емотивно биће"],
    },
    {
      q: "Ако се човек дефинише као „zoon politicon“, он је:",
      a: ["политичка животиња", "емотивна животиња", "производно биће", "биће способно за игру"],
    },
    {
      q: "Правила о томе „како би требало да буде“ називају се:",
      a: ["норме", "вредности", "друштвене улоге", "друштвени положаји"],
    },
    {
      q: "Идеје према којима појединци и друштва теже да осмисле свој живот називају се:",
      a: ["вредност", "норме", "друштвене улоге", "друштвени положај"],
    },
    {
      q: "Скуп међусобно повезаних вредности назива се:",
      a: ["вредносни систем", "нормативни систем", "друштвени систем", "законодавни систем"],
    },
    {
      q: "Процес усвајања културе назива се:",
      a: ["социјализација", "национализација", "демократизација", "диференцијација"],
    },
    {
      q: "Функција је:",
      a: ["улога коју елемент има у систему", "друштвени положај", "целина састављена од елемената", "друштвена група чији чланови имају осећај блискости"],
    },
    {
      q: "Друштво је:",
      a: ["друштвена група чије чланове повезује неки интерес", "мањи или већи број људи на одређеној територији", "мањи број људи повезан духовним сродством", "мањи број људи повезан крвним сродством"],
    },
    {
      q: "Промена слојног положаја појединца у односу на рoдитеље назива се:",
      a: ["међугенерацијска покретљивост", "унутаргенерацијска покретљивост", "еволуција", "револуција"],
    },
    {
      q: "Промена слојног положаја појединца у односу на његов ранији положај назива се:",
      a: ["унутаргенерацијска покретљивост", "међугенерацијска покретљивост", "друштвена стратификација", "друштвена репродукција"],
    },
    {
      q: "Друштво у коме слојни положај појединца зависи од његове способности назива се:",
      a: ["меритократско друштво", "демократија", "аутократија", "цивилизација"],
    },
    {
      q: "Према Марксу, непријатељски супротстављени слојеви називају се:",
      a: ["класе", "касте", "елите", "друштвене групе"],
    },
    {
      q: "Два најпознатија схватања бирократије формулисали су:",
      a: ["Карл Маркс и Макс Вебер", "Огист Конт и Сен Симон", "Емил Диркем и Роберт Мертон", "Ентони Гиденс и Мајкл Хараламбос"],
    },
    {
      q: "Струка је:",
      a: ["заједница људи исте професије", "скуп истомишљеника", "синоним за друштвени статус", "врста друштвене промене"],
    },
    {
      q: "Друштвени положај је исто што и:",
      a: ["друштвени статус", "друштвени простор", "друштвено време", "друштвена улога"],
    },
    {
      q: "Скуп неписаних прописа о очекиваном понашању појединца назива се:",
      a: ["друштвена улога", "друштвени положај", "друштвене вредности", "друштвени статус"],
    },
    {
      q: "Друштвени положај који је учинак личног постигнућа назива се:",
      a: ["стечени статус", "приписани статус", "лични статус", "одбачени статус"],
    },
    {
      q: "Друштвени положај који се добија рођењем назива се:",
      a: ["приписани статус", "стечени статус", "одбачени статус", "лични статус"],
    },
    {
      q: "Способност постизања добровољне послушности назива се:",
      a: ["моћ", "статусна група", "статусни симбол", "углед"],
    },
    {
      q: "Највиша статусна група назива се:",
      a: ["елита", "слој", "класа", "сталеж"],
    },
    {
      q: "Оснивач теорије елите је:",
      a: ["Вилфредо Парето", "Огист Конт", "Макс Вебер", "Емил Диркем"],
    },
    {
      q: "Владајућу елиту назива политичком класом:",
      a: ["Гаетано Моска", "Вилфредо Паредо", "Рајт Милс", "Карл Маркс"],
    },
    {
      q: "Ниже класе којима управља елита називају се:",
      a: ["маса", "касте", "сталежи", "друштвене групе"],
    },
    {
      q: "Родоначелник модерне идеје о друштвеној једнакости је:",
      a: ["Жан-Жак Русо", "Карл Маркс", "Фридрих Енгелс", "Емил Диркем"],
    },
    {
      q: "Неравноправне могућности мушкараца и жена називају се:",
      a: ["родне неједнакости", "сексуална револуција", "класне неједнакости", "глобалне неједнакости"],
    },
    {
      q: "Промена која значи квантитативно увећање неке појаве назива се:",
      a: ["друштвени раст", "друштвени развој", "друштвени прогрес", "релативна стагнација"],
    },
    {
      q: "Кретање према идеалном друштвеном поретку назива се:",
      a: ["друштвени прогрес", "друштвени раст", "друштвени развој", "релативна стагнација"],
    },
    {
      q: "Промена која значи достизање сложенијег и савршенијег стања неке појаве назива се:",
      a: ["друштвени развој", "друштвени прогрес", "друштвени раст", "релативна стагнација"],
    },
    {
      q: "Друштвене промене покреће усавршавање производних снага, сматра:",
      a: ["Карл Маркс", "Херберт Спенсер", "Емил Диркем", "Огист Конт"],
    },
    {
      q: "Друштвене промене тумаче се као смена фаза напредовања и назадовања према:",
      a: ["цикличном становишту", "еволуционистичком становишту", "функционалистичком становишту", "формалистичком становишту"],
    },
    {
      q: "Демографија је:",
      a: ["наука о становништву", "наука о демонима", "наука о графитима", "грана дефектологије"],
    },
    {
      q: "Скуп лица која живе на одређеној територији назива се:",
      a: ["популација", "држава", "друштво", "нација"],
    },
    {
      q: "Механичко кретање становништва чине:",
      a: ["миграције", "наталитет", "морталитет", "природни прираштај"],
    },
    {
      q: "Природно кретање становништва чине:",
      a: ["наталитет и морталитет", "миграције", "склапање брака", "развод брака"],
    },
    {
      q: "Број рођених на 1 000 становника назива се:",
      a: ["наталитет", "морталитет", "миграције", "природни прираштај"],
    },
    {
      q: "Број умрлих на 1 000 становника назива се:",
      a: ["морталитет", "наталитет", "миграције", "природни прираштај"],
    },
    {
      q: "Разлика између наталитета и морталитета назива се:",
      a: ["природни прираштај", "развој", "прогрес", "релативна стагнација"],
    },
    {
      q: "Имиграција означава:",
      a: ["досељавање", "одсељавање", "број рођених", "број умрлих"],
    },
    {
      q: "Емиграција је исто што и:",
      a: ["одсељавање", "досељавање", "број рођених", "број умрлих"],
    },
    {
      q: "Рад у социолошком смислу је:",
      a: ["свесна, сврсисходна активност којом човек даје употребну вредност добрима", "стварање материјалних вредности", "однос човека према природи и однос људи међусобно", "стварање духовних вредности"],
    },
    {
      q: "Основни чиниоци друштвене производње су:",
      a: ["човек, средства за рад, предмети рада", "својински односи, радна снага, роба", "подређени, надређени, производи", "произвођачи, производни односи, потрошачи"],
    },
    {
      q: "Могућност производа да задовољи одређену људску потребу или жељу назива се:",
      a: ["употребна вредност", "стваралачка вредност", "вредност", "друштвена делатност"],
    },
    {
      q: "Диференцирање сложеног радног задатка на једноставније елементе рада назива се",
      a: ["техничка подела рада", "друштвена подела рада", "умни рад", "физички рад"],
    },
    {
      q: "Институционално организована целина унутар које се остварује било који вид радне делатности назива се:",
      a: ["радна организација", "демократија", "бирократија", "аутократија"],
    },
    {
      q: "Културни садржаји који се у једној заједници преносе с поколења на поколење чине:",
      a: ["традицију", "језик", "симболе", "ритуале"],
    },
    {
      q: "Дела чија је вредност општепризната чине:",
      a: ["високу културу", "народну културу", "масовну културу", "популарну културу"],
    },
    {
      q: "Образац понашања у области потрошње, међуљудске интеракције и личног изражавања назива се:",
      a: ["стил живота", "народна култура", "масовна култура", "популарна култура"],
    },
    {
      q: "Поучна прича о нечему што се збило у значајној прошлости назива се:",
      a: ["мит", "религија", "магија", "обред"],
    },
    {
      q: "Веровање у једног бога познато је као:",
      a: ["монотеизам", "политеизам", "атеизам", "аскетизам"],
    },
    {
      q: "Секта је:",
      a: ["верска заједница", "политичка заједница", "културна заједница", "економска заједница"],
    },
    {
      q: "Вештина управљања друштвом назива се:",
      a: ["политика", "култура", "економија", "морал"],
    },
    {
      q: "Организације које се боре за освајање и вршење власти називају се",
      a: ["политичке странке", "друштвени покрети", "рекреативна друштва", "спортска друштва"],
    },
    {
      q: "Облик државе у којој је власт доживотна и по правилу се наслеђује назива се:",
      a: ["монархија", "република", "парламентарна власт", "саветодавно тело"],
    },
    {
      q: "Облик државе где власт врше изабрани представници грађана назива се:",
      a: ["република", "монархија", "парламентарна власт", "саветодавно тело"],
    },
    {
      q: "Нације су:",
      a: ["историјски формиране етничке заједнице", "историјски формиране репродуктивне заједнице", "историјски формиране интересне заједнице", "друштвено-политичке заједнице"],
    },
    {
      q: "Систем идеја којим се правдају интереси одређених друштвених слојева назива се:",
      a: ["идеологија", "теорија", "емпирија", "пракса"],
    },
    {
      q: "Идеологија која се залаже за што већу слободу појединца у друштву назива се:",
      a: ["либерализам", "конзервативизам", "традиционализам", "капитализам"],
    },
    {
      q: "Идеје једнакости и солидарности у организовању друштва заступа:",
      a: ["социјализам", "либерализам", "фашизам", "анархизам"],
    },
    {
      q: "Уништењу државе теже:",
      a: ["анархисти", "социјалисти", "либерали", "фашисти"],
    },
    {
      q: "Крајњи национализам и расизам одликују:",
      a: ["фашизам", "социјализам", "либерализам", "анархизам"],
    },
    {
      q: "Увођење детета у друштвену културу назива се:",
      a: ["култивација", "персонализација", "индивидуализација", "друштвена контрола"],
    },
    {
      q: "Процес постепеног повећања просечне температуре планете Земље назива се:",
      a: ["глобално загревање", "одрживи развој", "ризично друштво", "урбанизација"],
    },
    {
      q: "Аномија је:",
      a: ["слабљење друштвених норми", "веровање у духове", "јачање друштвених норми", "врста наркотика"],
    },
    {
      q: "Деаграризација је:",
      a: ["напуштање пољопривреде", "смањена смртност становништва", "пресељавање из градова у село", "повећање броја сеоског становништва"],
    },
    {
      q: "Ширење индустријске производње познато је као:",
      a: ["индустријализација", "деиндустријализација", "пацифизам", "национализам"],
    },
    {
      q: "Схватање према коме су земље Европе супериорније од других земаља назива се:",
      a: ["евроцентризам", "глобализам", "империјализам", "национализам"],
    },
    {
      q: "Моногамија је:",
      a: ["брак са једним партнером", "брак са више партнера", "облик државног уређења", "облик социјалне патологије"],
    },
  ]
